(ns hai.web-app.feature-flag.ui
  (:require
   [hai.ui.components :as c]
   [hai.ui.rf-sugar :refer [<s >e]]
   [lambdaisland.ornament :as o]))

(o/defstyled flag-container :div
  {:display "flex"
   :max-width "600px"
   :flex-direction "column"
   :gap "12px"
   :padding "16px"
   :background-color "var(--color-bg-secondary)"
   :border-radius "8px"
   :border "1px solid var(--color-border)"})

(o/defstyled flag-row :div
  {:display "flex"
   :border "2px solid var(--gray-4)"
   :align-items "center"
   :justify-content "space-between"
   :padding "8px 12px"
   :border-radius "4px"
   :transition "background-color 0.2s"
   "&:hover" {:background-color "var(--color-bg-hover)"}})

(o/defstyled flag-info :div
  {:display "flex"
   :flex-direction "column"
   :gap "4px"
   :flex 1})

(o/defstyled flag-name :div
  {:font-weight "500"
   :color "var(--color-text-primary)"})

(o/defstyled flag-description :div
  {:font-size "0.875rem"
   :color "var(--color-text-secondary)"})

(defn beta-features-toggle []
  [flag-row
   [flag-info
    [flag-name "Beta features"]
    [flag-description "Access early beta features and experiments"]]
   [c/Switch
    {:checked @(<s :feature-flag/beta-features?)
     :on-checked-change #(>e [:feature-flag/toggle-beta-features])}]])

(defn developer-features-toggle []
  [flag-row
   [flag-info
    [flag-name "Developer features"]
    [flag-description "Things under construction. Or dev tools."]]
   [c/Switch
    {:checked @(<s :feature-flag/developer-features?)
     :on-checked-change #(>e [:feature-flag/toggle-developer-features])}]])

(defn legacy-features-toggle []
  [flag-row
   [flag-info
    [flag-name "Legacy features"]
    [flag-description "Show legacy entities (chats, AI sources, solutions)"]]
   [c/Switch
    {:checked @(<s :auth/legacy?)
     :on-checked-change #(>e [:auth/toggle-legacy])}]])

(defn feature-flags-panel []
  [flag-container
   [:h4 "Feature Flags"]
   [beta-features-toggle]
   [legacy-features-toggle]
   (when @(<s :auth/admin?)
     [developer-features-toggle])])
